import React, {useContext} from "react";
import {IKensuCalendarEventProto, KensuCalendarEventProto, space} from "../../../../provider_api";
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {EditableSingleSelect} from "../../../../components/Editable/EditableSingleSelect";
import {RepeatStrategyEditor} from "./RepeatStrategyEditor";
import {filterErrors} from "../../../../components/input/InputTypes";
import {EditableContext} from "../../../../components/Editable/EditableContext";

type Props = {
  officeOptions: { value: string, label: string }[]
}

/**
 * Editor for availability blocks - creating, editing. Note this uses the LIVE profile
 * to find the list of practitioners, since the calendar is not versioned.
 */
export const AvailabilityBlockEditor = (props: Props) => {

  const {mode, workingCopy} = useContext<EditableContext<KensuCalendarEventProto>>(EditableContext);

  const {businessProfile} = useProviderProfile();

  return <>
    <EditableSingleSelect<IKensuCalendarEventProto, string>
        label={'Choose a practitioner'}
        getter={instance => instance.availability?.details?.practitionerId}
        setter={(instance, value) => new KensuCalendarEventProto({
          ...instance,
          availability: {
            ...instance.availability,
            details: {
              ...instance.availability?.details,
              practitionerId: value
            }
          }
        })}
        errorKey={'practitionerId'}
        options={businessProfile?.practitioners?.filter(p => !p.archived).map(provider => {
          return {
            value: provider.practitionerId as string,
            label: provider.firstName + ' ' + provider.lastName
          }
        }) || []}
    />

    <EditableSingleSelect<IKensuCalendarEventProto, string>
        label={'Choose a location'}
        getter={instance => instance.availability?.details?.locationId}
        setter={(instance, value) => new KensuCalendarEventProto({
          ...instance,
          availability: {
            ...instance.availability,
            details: {
              ...instance.availability?.details,
              locationId: value
            }
          }
        })}
        errorKey={'offices'}
        options={props.officeOptions}
    />

    <RepeatStrategyEditor<IKensuCalendarEventProto>
        startTimestamp={workingCopy.startTimestamp as number}
        immutable={mode == 'update'}
        label={'Recurring'}
        errorKey={'repeatStrategy'}
        getter={instance => instance.availability?.repeatStrategy}
        setter={(instance, value) => {
          console.log('new value: ', value);
          return new KensuCalendarEventProto({
            ...instance,
            availability: {
              ...instance.availability,
              repeatStrategy: value
            }
          })
        }
        }
    />
  </>
}